import initialState from '../initialState.js';
import {
    GET_HEALTH_USAGE,
    ADD_HEALTH_USAGE,
    GET_LIFESTYLE_CLAIMS,
    ADD_LIFESTYLE_CLAIM,
    GET_LSA_CLAIMS_SUCCESS,
    GET_HSA_CLAIMS_SUCCESS
} from '../../actions/types/spendingAccounts';

export default (state = initialState.spendingAccounts, action) => {
    switch (action.type) {
        case GET_HEALTH_USAGE: {
            return {
                ...state,
                health: {
                    items: action.health.items,
                    remaining: action.health.remaining,
                    total: action.health.total
                }
            };
        }

        case GET_LIFESTYLE_CLAIMS: {
            return {
                ...state,
                lifestyle: {
                    items: action.lifestyle.items,
                    remaining: action.lifestyle.remaining,
                    total: action.lifestyle.total
                },
                lsaClaimTypes: action.lsaClaimTypes
            };
        }

        case ADD_HEALTH_USAGE: {
            return {
                ...state,
                health: {
                    ...state.health,
                    items: [ action.data, ...state.health.items ],
                    remaining: state.health.remaining - action.data.amountUsed
                }
            };
        }

        case ADD_LIFESTYLE_CLAIM: {
            return {
                ...state,
                lifestyle: {
                    ...state.lifestyle,
                    items: [ action.data, ...state.lifestyle.items ],
                    remaining: state.lifestyle.remaining - action.data.amountUsed
                }
            };
        }

        case GET_LSA_CLAIMS_SUCCESS: {
            return {
                ...state,
                lifestyle: {
                    ...state.lifestyle,
                    items: action.claims
                }
            };
        }

        case GET_HSA_CLAIMS_SUCCESS: {
            return {
                ...state,
                health: {
                    ...state.health,
                    items: action.claims
                }
            };
        }

        default:
            return state;
    }
};